import { createContext, useContext } from 'react';

type LifecycleContextValue = {
  setCopyDirty: (dirty: boolean) => void;
  refreshOpenCount: () => void;
};

const noop = () => undefined;

const LifecycleContext = createContext<LifecycleContextValue>({
  setCopyDirty: noop,
  refreshOpenCount: noop,
});

export const LifecycleProvider = LifecycleContext.Provider;

export const useLifecycle = () => useContext(LifecycleContext);
